import React, { useState, useEffect } from "react";
import { Row, Col, Card, Input, Divider, Button, Select } from "antd";
import styled from "styled-components";
import { BsFolder } from "react-icons/all";
import { useSelector, useDispatch } from "react-redux";
import { CatalogAction } from "../../store/actions";
import { useHistory } from "react-router-dom";
import { UNIT_METRIC } from "../../config/utils";

const { Option } = Select;
const CardWrapper = styled(Card)`
  min-height: 400px;
`;
const arr = [];
const arr2 = [];
const { TextArea } = Input;
function General_Info({ isShowUpdateProduct, textHeading, location }) {
  const [imageUrl, setImageUrl] = useState("");
  const [productId, setProductId] = useState(location?.state?.id);
  const [additiveFormData, setAdditiveFormData] = useState([]);
  // const [productDetail, setProductDetail] = useState(location.state || {});
  const dispatch = useDispatch();
  const history = useHistory();

  const getBasmixes = (params) =>
    dispatch(CatalogAction.getBasemixesReq(params));
  const getAdditives = (params) =>
    dispatch(CatalogAction.getAdditivesReq(params));
  const getCategories = (params) =>
    dispatch(CatalogAction.getBasemixesCategoriesReq(params));
  useEffect(() => {
    getBasmixes();
    getAdditives();
    getCategories();
  }, []);

  const dataInBasemix = useSelector(
    (store) => store?.CatalogReducer?.basemixes
  );
  const additivesData = useSelector(
    (store) => store?.CatalogReducer?.additives
  );
  const categoriesData = useSelector(
    (store) => store?.CatalogReducer?.basemixesCategories
  );

  const basemixData = useSelector(
    (store) => store?.CatalogReducer?.basemixData
  );

  const [customProduct, setCustomProduct] = useState(
    { ...location.state, product_additive: [] } || {
      status: "",
      unit: "",
      name: "",
      product_additive: [],
    }
  );

  const [customError, setError] = useState({
    nameError: "",
    unitError: "",
    category_idError: "",
    basemix_idError: "",
  });

  if (!arr.length) {
    const abc = basemixData.forEach((item) => {
      item.basemixes.map((v) => {
        arr.push({ name: v.name, id: v.id });
      });
    });
  }

  const postCustomProductData = () => {
    const requiredAdditiveData = (additiveFormData || []).map((el) => {
      const data = additivesData.find((aditiveData) => aditiveData.name == el);
      return data;
    });

    const payload = {
      ...customProduct,
      product_additive: requiredAdditiveData.map((el) => el.id),
      product_additives: requiredAdditiveData,
    };

    const err = { ...customError };
    if (
      !customProduct.name?.trim().length ||
      !customProduct?.basemix_id ||
      !customProduct?.category_id ||
      !customProduct?.unit
    ) {
      if (!customProduct?.name?.trim().length) {
        err.nameError = "Product name is required.";
      }
      if (!customProduct?.category_id) {
        err.category_idError = "Category name is required..";
      }
      if (!customProduct?.basemix_id) {
        err.basemix_idError = "Product taxable is required..";
      }
      if (!customProduct?.unit) {
        err.unitError = "Required";
      }
      setError(err);
      return;
    }

    console.log("customProduct===>", customProduct);
    if (!location?.state?.id) {
      dispatch(
        CatalogAction.postCustomProductReq(customProduct, () =>
          history.push("/product")
        )
      );
    } else {
      dispatch(
        CatalogAction.updateCustomProductReq(payload, productId, () =>
          history.push("/product")
        )
      );
    }
  };

  let inputRef;
  const abc = additivesData
    .filter((item) => {
      return customProduct?.product_additives?.some((v) => {
        return v.additive_id == item.id;
      });
    })
    .map((item) => {
      return item.name;
    });

  useEffect(() => {
    let arr = [...additiveFormData];
    arr = abc;
    setAdditiveFormData(arr);
  }, [additivesData]);

  const filterOption = additivesData.filter((item) =>
    additiveFormData.every((v) => item.name !== v)
  );

  useEffect(() => {
    let mydata = [...arr2];
    console.log("myData==>", mydata);
  }, [location?.state?.product_additives]);

  // const productAdditives = location?.state?.product_additives.forEach((item) => {
  //   return arr2.push(item.additive_id);
  // });
  console.log("productAdditives===>", dataInBasemix);
  return (
    <CardWrapper style={{ marginTop: "10px" }}>
      <Row gutter={[20, 10]}>
        <Col
          span={24}
          className="st-table-header"
          style={{ marginBottom: "10px" }}
        >
          <h5
            className="text-left general-text-heading"
            style={{
              fontSize: "20px",
              color: "#323761",
            }}
          >
            {!location?.state?.id ? "New Product" : "Update Product"}
          </h5>
        </Col>
        <Col span={24}>
          <h5
            className="text-left"
            style={{
              fontSize: "20px",
              color: "#323761",
            }}
          >
            General Information
          </h5>
        </Col>
        <Col xl={5} lg={6} md={24} sm={24} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={12} lg={12} xs={11} sm={11} md={4} className="text-left">
              <label style={{ fontSize: "12px" }}>
                Product Name
                <span style={{ color: "orange", fontSize: "10px" }}>*</span>
              </label>
            </Col>
            <Col xl={24} xs={24}>
              <Input
                onChange={(e) => {
                  setCustomProduct({
                    ...customProduct,
                    name: e.target.value,
                  });
                  setError({
                    ...customError,
                    nameError: "",
                  });
                }}
                value={customProduct?.name}
              />
              <Row justify="start">
                <Col>
                  <span className="danger-color text-left">
                    {customError.nameError && customError.nameError}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Col />
        </Col>
        {/* <Col xl={3} md={24} lg={4} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={12} xs={9} sm={9} md={4} lg={10} className="text-left">
              <label style={{ fontSize: "12px" }}>Product Sku</label>
            </Col>
            <Col xl={24} xs={24}>
              <Input
                onChange={(e) => {
                  setCustomProduct({
                    ...customProduct,
                    sku: e.target.value,
                  });
                }}
                value={customProduct?.sku}
              />
            </Col>
          </Row>
          <Col />
        </Col>
        <Col xl={2} md={24} lg={6} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={12} xs={4} sm={9} md={2} lg={12} className="text-left">
              <label style={{ fontSize: "12px" }}>Weight</label>
            </Col>
            <Col xl={24} xs={24}>
              <Input
                onChange={(e) =>
                  setCustomProduct({
                    ...customProduct,
                    weight: e.target.value,
                  })
                }
                value={customProduct?.weight}
              />
            </Col>
          </Row>
          <Col />
        </Col> */}
        <Col xl={6} md={24} lg={6} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={12} xs={4} sm={9} md={2} lg={12} className="text-left">
              <label style={{ fontSize: "12px" }}>Unit</label>
            </Col>
            <Col xl={24} xs={24}>
              <Select
                style={{ width: "100%", textAlign: "left" }}
                onChange={(e, i) => {
                  setCustomProduct({
                    ...customProduct,
                    unit: i?.value,
                  });
                  setError({
                    ...customError,
                    unitError: "",
                  });
                }}
                value={customProduct.unit}
                placeholder="Select unit"
              >
                {UNIT_METRIC.map((unitName, index) => {
                  return (
                    <Option key={index} value={unitName}>
                      {unitName}
                    </Option>
                  );
                })}
              </Select>
              <Row justify="start">
                <Col>
                  <span className="danger-color text-right">
                    {customError.unitError && customError.unitError}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Col />
        </Col>
        <Col xl={6} md={24} lg={6} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={12} sm={12} md={5} lg={12} className="text-left">
              <label style={{ fontSize: "12px" }}>
                Product Taxable
                <span style={{ color: "orange", fontSize: "9px" }}>*</span>
              </label>
            </Col>
            <Col xl={24} xs={24}>
              <Select
                style={{ width: "100%", textAlign: "left" }}
                onChange={(e, i) => {
                  setCustomProduct({
                    ...customProduct,
                    basemix_id: i?.value,
                    basemix: { ...customProduct?.basemix, name: i?.children },
                  });
                  setError({
                    ...customError,
                    basemix_idError: "",
                  });
                }}
                placeholder="Select Product Taxable"
                value={customProduct?.basemix?.name}
              >
                {(dataInBasemix || []).map((productName) => {
                  return (
                    <Option key={productName?.id} value={productName?.id}>
                      {productName?.name}
                    </Option>
                  );
                })}
              </Select>
              <Row justify="start">
                <Col>
                  <span className="danger-color text-right">
                    {customError.basemix_idError && customError.basemix_idError}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Col />
        </Col>
        <Col xl={6} md={24} lg={6} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={12} sm={12} md={5} lg={12} className="text-left">
              <label style={{ fontSize: "12px" }}>
                Product Categories
                <span style={{ color: "orange", fontSize: "9px" }}>*</span>
              </label>
            </Col>
            <Col xl={24} xs={24}>
              <Select
                style={{ width: "100%", textAlign: "left" }}
                onChange={(e, i) => {
                  setCustomProduct({
                    ...customProduct,
                    category_id: i?.value,
                    category: { ...customProduct?.category, name: i?.children },
                  });
                  setError({
                    ...customError,
                    category_idError: "",
                  });
                }}
                placeholder="Select Product Categories"
                value={customProduct?.category?.name}
              >
                {categoriesData.map((productName) => {
                  return (
                    <Option key={productName?.id} value={productName?.id}>
                      {productName?.name}
                    </Option>
                  );
                })}
              </Select>
              <Row justify="start">
                <Col>
                  <span className="danger-color text-right">
                    {customError.category_idError &&
                      customError.category_idError}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Col />
        </Col>
        <Col xl={3} sm={12} md={6} lg={12} className="text-left">
          <label style={{ fontSize: "12px" }}>Product Description</label>
        </Col>
        <Col xl={24} xs={24} md={24}>
          <TextArea
            autoSize={{ minRows: 3, maxRows: 5 }}
            onChange={(e) =>
              setCustomProduct({
                ...customProduct,
                description: e.target.value,
              })
            }
            value={customProduct?.description}
          />
        </Col>
        <Col xl={24}>
          <Divider />
        </Col>
        <Col span={24}>
          <Row justify="start">
            <Col
              xl={24}
              sm={24}
              xs={24}
              md={24}
              className="text-left"
              style={{ marginBottom: "10px" }}
            >
              <h5
                style={{
                  fontSize: "20px",
                  color: "#323761",
                }}
              >
                Additives
              </h5>
            </Col>
            <Col
              xl={12}
              lg={12}
              sm={24}
              xs={24}
              md={24}
              className="pointer-cursor"
            >
              <Select
                mode="multiple"
                className="pointer-cursor"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(e, i) => {
                  const product_additive = additivesData
                    .filter((item) => {
                      return e.some((v) => {
                        return item.name == v;
                      });
                    })
                    .map((item) => {
                      return item.id;
                    });
                  // console.log("on_change==>", product_additive);
                  const v = {
                    ...customProduct,
                    product_additive: product_additive,
                  };
                  // const a = v.product_additive?.pus(i?.value);
                  setCustomProduct(v);
                }}
                value={additiveFormData}
                placeholder="Select Product Additives"
                onDeselect={(e, v) => {
                  const deletedIndex = additiveFormData.findIndex(
                    (item) => item == e
                  );
                  console.log("eee==>", e);
                  const arr = [...additiveFormData];
                  const cusProduct = { ...customProduct };
                  console.log("cusProduct==>", cusProduct);
                  arr.splice(deletedIndex, 1);
                  console.log("customProduct deSelect", arr);

                  setAdditiveFormData(arr);
                }}
                onSelect={(i, j) => {
                  console.log("V==>", i, j, "/n", additiveFormData);
                  const arr = [...additiveFormData];
                  const v = { ...customProduct };
                  v?.product_additive?.push(i);
                  arr.push(j.children);
                  setAdditiveFormData(arr);
                  setCustomProduct(v);
                }}
              >
                {filterOption.map((data) => {
                  return (
                    <Option
                      key={data.id}
                      value={data.id}
                      className="pointer-cursor"
                    >
                      {data.name}
                    </Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
        </Col>
        <Col xl={24}>
          <Divider />
        </Col>
        <Col xl={24} sm={24} xs={24}>
          <Row justify="start">
            <Col
              xl={24}
              sm={24}
              xs={24}
              md={24}
              className="text-left"
              style={{ marginBottom: "10px" }}
            >
              <h5
                style={{
                  fontSize: "20px",
                  color: "#323761",
                }}
              >
                Images
              </h5>
            </Col>
            <Col
              xl={4}
              lg={3}
              md={8}
              xs={24}
              sm={24}
              className="pointer-cursor"
              style={{
                border: "solid 1px ",
                padding: imageUrl ? "0rem" : "2rem",
              }}
            >
              {imageUrl ? (
                <img
                  width="120"
                  height="100"
                  src={imageUrl}
                  style={{ objectFit: "contain" }}
                />
              ) : location?.state?.id ? (
                <img
                  width="120"
                  height="100"
                  src={customProduct?.image?.original}
                  style={{ objectFit: "contain" }}
                />
              ) : (
                <BsFolder size="40" color="grey" />
              )}
            </Col>
            <Col
              // xl={3}
              // lg={3}
              // md={6}
              // sm={12}
              // xs={12}
              xl={12}
              sm={10}
              xs={24}
              // style={{ marginTop: "20px" }}
              style={{ padding: "14px" }}
            >
              <Row justify="start">
                <Col className="text-left" span={24}>
                  <small
                    style={{ fontSize: "80%", color: "#bdbdbd" }}
                    className="pointer-cursor"
                  >
                    IMAGE SIZE: 150X150
                  </small>
                </Col>
                <Col
                  className="text-left"
                  span={24}
                  style={{ marginTop: "10px" }}
                >
                  <Button
                    style={{
                      backgroundColor: "#26a69a",
                      color: "#fff",
                      letterSpacing: ".5px",
                      transition: ".2s ease-out(red)",
                      fontSize: "12px",
                    }}
                    onClick={() => inputRef.click()}
                  >
                    {!location?.state?.id ? "ADD IMAGE" : "CHANGE IMAGE"}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify="end">
            <Col xl={4} sm={12} xs={12}>
              <Button
                style={{
                  backgroundColor: "#f57c00 ",
                  color: "#fff",
                  width: "100%",
                  letterSpacing: ".5px",
                  transition: ".2s ease-out(red)",
                  fontSize: "12px",
                }}
                onClick={() => postCustomProductData(customProduct)}
              >
                SAVE
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <input
        onChange={(e) => {
          var reader = new FileReader();
          reader.readAsDataURL(e.target.files[0]);
          reader.onload = function () {
            setImageUrl(reader.result);
          };
          setCustomProduct({
            ...customProduct,
            image: e.target.files[0],
          });
        }}
        className="d-none"
        ref={(ref) => (inputRef = ref)}
        type="file"
      />
    </CardWrapper>
  );
}
export default General_Info;
